export default "__VITE_ASSET__C2j_8HvB__"